import { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForStandardToPremium({
	product,
	config: { isPaidStandard },
	userRoles,
	trialOfferingName,
}: EditionAwarenessContextType): boolean {
	return !!(
		['confluence', 'jira', 'jira-service-management'].includes(product) &&
		isPaidStandard &&
		userRoles?.includes('SITE_ADMIN') &&
		trialOfferingName === 'premium'
	);
}
